import { extractParlayLegs } from "../components/lib/betSlipBuyPoints";
import {
  getLegPricesFromSelections,
  PARLAY_MIN_LEGS,
} from "./parlayOdds";

/** First user-facing message from ticket validation errors. */
export function summarizeTicketValidationErrors(errors) {
  if (!errors || typeof errors !== "object") return null;

  if (typeof errors.legs === "string" && errors.legs) return errors.legs;
  if (typeof errors.amount === "string" && errors.amount) return errors.amount;
  if (typeof errors.type === "string" && errors.type) return errors.type;
  if (typeof errors.validation === "string" && errors.validation) {
    return errors.validation;
  }

  if (Array.isArray(errors.data)) {
    for (const row of errors.data) {
      if (!row || typeof row !== "object") continue;
      const msg = Object.values(row).find(
        (value) => typeof value === "string" && value.trim().length > 0
      );
      if (msg) return msg;
    }
  }

  const fallback = Object.values(errors).find(
    (value) => typeof value === "string" && value.trim().length > 0
  );
  return (
    fallback ||
    "Please fix the highlighted bet fields before submitting."
  );
}

/** Normalize API / axios errors into a toast-friendly message. */
export function resolveOrderSubmitErrorMessage(response, err) {
  if (response?.message && String(response.message).trim()) {
    return String(response.message).trim();
  }

  if (typeof response?.error === "string" && response.error.trim()) {
    return response.error.trim();
  }

  const apiMessage = err?.response?.data?.message;
  if (apiMessage && String(apiMessage).trim()) {
    return String(apiMessage).trim();
  }

  if (err?.message && String(err.message).trim()) {
    return "Unable to place bet. Please try again.";
  }

  return "Unable to place bet. Please try again.";
}

/** Client-side parlay guards before submit (no page navigation). */
export function validateParlayBeforeSubmit({
  legs,
  stake,
  minLegs = PARLAY_MIN_LEGS,
}) {
  const list = Array.isArray(legs) ? legs.filter(Boolean) : [];

  if (list.length < minLegs) {
    return {
      ok: false,
      message: `Select at least ${minLegs} legs for a parlay bet.`,
    };
  }

  const legPrices = getLegPricesFromSelections(list);
  if (legPrices.length !== list.length) {
    return {
      ok: false,
      message: "One or more parlay legs are missing valid odds.",
    };
  }

  const amount = Number(stake);
  if (!Number.isFinite(amount) || amount <= 0) {
    return {
      ok: false,
      message: "Please enter a valid parlay stake amount.",
    };
  }

  const payout = Number(list[0]?.payout);
  if (!Number.isFinite(payout) || payout <= 0) {
    return {
      ok: false,
      message:
        "Parlay payout could not be calculated. Re-enter your stake amount.",
    };
  }

  return { ok: true };
}

/** Flat or nested submit payload → parlay legs array. */
export function getParlayLegsFromSubmitData(data) {
  return extractParlayLegs(data);
}
